import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
} from "@material-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import { Service } from "../_generated";
import {
  ServiceWebappFields,
  ServiceContainerFields,
} from "../components/ServiceFields";

export default function ServiceEditDialog(props: {
  open: boolean;
  service: Service;
  onCancel: () => any;
  onSubmit: (data: Service) => any;
}) {
  const serviceType = props.service.service_type;
  const { register, handleSubmit, errors } = useForm();
  return (
    <Dialog open={props.open}>
      <form
        onSubmit={handleSubmit((data: any) => {
          props.onSubmit({
            pk: props.service.pk,
            ...data,
          });
        })}
      >
        <DialogTitle>Edit Service</DialogTitle>

        <DialogContent>
          <Grid
            container
            spacing={2}
            direction="column"
            alignItems="flex-start"
          >
            <Grid item xs={12}>
              {serviceType === "container" && (
                <ServiceContainerFields
                  service={props.service}
                  register={register}
                  errors={errors}
                />
              )}
              {serviceType === "webapp" && (
                <ServiceWebappFields
                  service={props.service}
                  register={register}
                  errors={errors}
                />
              )}
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button type="submit">{props.service ? "Save" : "Create"}</Button>
          <Button onClick={props.onCancel}>Cancel</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
